import Api from '@/api'
import PermissionFilter from '@/utilities/auth/permission/data/PermissionFilter'
import StringFormat from '@/utilities/helper/StringFormat'

const api = new Api()
const apiAdjustment = api.adjustment()

export default {
  async fetchPermissions({ commit }) {
    try {
      const { data } = await apiAdjustment.permission().all()
      const { settings } = data.data
      const permissions = new PermissionFilter(data.data.permissions).filter()

      commit('setChanges', [])
      commit('setPermissions', permissions)
      commit(
        'setRoles',
        settings.roles.map(item => ({
          ...item,
          value: StringFormat.camelCaseToString(item.value),
        })),
      )
      commit(
        'setServices',
        settings.services.map(item => ({
          ...item,
          value: StringFormat.camelCaseToString(item.value),
        })),
      )

      return permissions
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },

  async store({ commit }, payload) {
    try {
      const { data } = await apiAdjustment.permission().save(payload)
      const permissions = new PermissionFilter(data.data.permissions).filter()

      commit('setChanges', [])
      commit('setPermissions', permissions)

      return permissions
    } catch (err) {
      commit(
        'Dashboard/setFeedback',
        {
          message: err,
          errors: 500,
        },
        { root: true },
      )
    }
  },
}
